import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import swal from "sweetalert";
// import Select from "react-select";
import { AddRoomDetails, GetResAgentList, GetResCorporatedetail, getReserRoomRateSelect, Property, ReservationMealplan, ReservationPreBooking, ReservationRateCode, ReservationRateCodeList, } from "../../Services/Service"
import ReservationSidebar from "../Commun/ReservationSidebar";
import ReservationHeader from "../Commun/ReservationHeader";
import { useProperty } from "../../PropertyContext";



export const BookingSearch = () => {
    const navigate = useNavigate();
    const { selectedProperty } = useProperty();
    const [loading, setLoading] = useState(false);
    const [checkIn, setCheckIn] = useState("");
    const [checkOut, setCheckOut] = useState("");
    const [rateTypeCode, setRateTypeCode] = useState("Property");
    // const [rateCodeID] = useState("1");
    const [totalRoom, setTotalRoom] = useState(1);
    const [roomDetails, setRoomDetails] = useState([]);
    const [selectedPlans, setSelectedPlans] = useState({});
    const [roomCounts, setRoomCounts] = useState({});
    const [showPopup, setShowPopup] = useState(false);
    const [agentList, setAgentList] = useState([]);
    const [selectedAgentId, setSelectedAgentId] = useState("");
    const [corporateList, setCorporateList] = useState([]);
    const [selectedCorporateId, setSelectedCorporateId] = useState("");
    const [roomOccupancy, setRoomOccupancy] = useState({});
    const [selectedRatePlans, setSelectedRatePlans] = useState({});
    const [selectedMealPlans, setSelectedMealPlans] = useState({});
    const [rateCodes, setRateCodes] = useState([]);
    const [Pms, setPMS] = useState();
    const [ratecode, setRatecode] = useState([]);
    const [mealplan, setMealplan] = useState([]);
    const [filteredMealplan, setFilteredMealplan] = useState([]);


    useEffect(() => {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(today.getDate() + 1);

        setCheckIn(today.toISOString().split("T")[0]);
        setCheckOut(tomorrow.toISOString().split("T")[0]);
    }, []);

    const handleCheckInChange = (e) => {
        const selectedDate = e.target.value;
        setCheckIn(selectedDate);

        const nextDay = new Date(selectedDate);
        nextDay.setDate(nextDay.getDate() + 1);

        const formattedNextDay = nextDay.toISOString().split("T")[0];
        setCheckOut(formattedNextDay);
    };

    // rate code type
    useEffect(() => {
        const fetchRateCodestype = async () => {
            setLoading(true);
            try {
                const res = await ReservationRateCode();
                if (res) {
                    setRateCodes(res);
                }
            } catch (error) {
                console.error("Error fetching rate codes:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRateCodestype();
    }, []);


    useEffect(() => {
        const FetchAgentName = async () => {
            try {
                const result = await GetResAgentList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    const filtered = result.filter(a => a.TA_Name && a.AgentID);
                    setAgentList(filtered);
                }
            } catch (error) {
                console.log("error get Agent Name", error);
            }
        };
        FetchAgentName();
    }, [selectedProperty]);

    useEffect(() => {
        const FetchCorporateDetail = async () => {
            try {
                const result = await GetResCorporatedetail(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    const filtered = result.filter(
                        (corp) => corp.CorporateID && corp.TA_Name
                    );
                    setCorporateList(filtered);
                }
            } catch (error) {
                console.log("error get corporate detail", error);
            }
        };

        FetchCorporateDetail();
    }, [selectedProperty]);




    const handleSearch = async () => {
        if (!checkIn || !checkOut) {
            swal("Please select Check-In and Check-Out dates.", {
                icon: "warning",
            });
            return;
        }

        if (!selectedProperty?.PropertyID) {
            swal("Please select property.", { icon: "warning" });
            return;
        }

        if (!totalRoom || totalRoom <= 0) {
            swal("Please select total rooms.", { icon: "warning" });
            return;
        }

        setLoading(true);

        try {
            let finalRateCodeID = 0;

            if (rateTypeCode === "Travel Agent") {
                finalRateCodeID = selectedAgentId || 0;
            } else if (rateTypeCode === "Corporate") {
                finalRateCodeID = selectedCorporateId || 0;
            }

            const result = await ReservationPreBooking(
                selectedProperty.PropertyID,
                checkIn,
                checkOut,
                rateTypeCode,
                finalRateCodeID,
                totalRoom
            );

            console.log("data", result?.RatePlan)
            setRoomDetails(result?.RatePlan || []);

            const token = result?.RoomDetails?.[0]?.PreBookingToken;
            if (token) {
                localStorage.setItem("PreBookingToken", token);
            }

        } catch (error) {
            console.error("error fetching booking", error);
            swal("Failed to fetch room availability.", { icon: "error" });
        } finally {
            setLoading(false);
        }
    };




    const handleRatePlanChange = (roomId, ratePlanCode, room) => {
        // try to find in room's own rateplans first
        const roomRatePlans = room?.RatePlan ? JSON.parse(room.RatePlan) : [];
        let selectedRatePlan = roomRatePlans.find(p => p.Code === ratePlanCode);

        // if not found in room, fallback to global ratecode from PropertyRateCode API
        if (!selectedRatePlan) {
            selectedRatePlan = ratecode.find(rc => rc.Code === ratePlanCode) || null;
        }

        setSelectedRatePlans(prev => ({
            ...prev,
            [roomId]: selectedRatePlan,
        }));

        // initialize selectedPlans so quantity/select room becomes available
        setSelectedPlans(prev => ({
            ...prev,
            [roomId]: {
                RatePlanID: selectedRatePlan?.RateCodeID ?? selectedRatePlan?.RatePlanID ?? null,
                RatePlanName: selectedRatePlan?.Name ?? selectedRatePlan?.Name ?? "",
                MealPlanCode: null,
                MealPlanName: null,
                PerRoomRate: 0,
                ExtraBedCharges: 0
            }
        }));

        // reset meal plan selection for that room (if you want)
        setSelectedMealPlans(prev => ({
            ...prev,
            [roomId]: null
        }));
    };



    const handleMealPlanChange = (roomId, mealPlanID) => {
        const mealPlan = filteredMealplan.find(mp => mp.MealPlanID === Number(mealPlanID)) || null;

        setSelectedMealPlans(prev => ({
            ...prev,
            [roomId]: mealPlan,
        }));

        setSelectedPlans(prev => ({
            ...prev,
            [roomId]: {
                ...prev[roomId],
                MealPlanCode: mealPlan?.Code || null,
                MealPlanName: mealPlan?.Name || null,
            }
        }));
    };


    const handleIncrement = async (roomID) => {
        const totalSelectedCount = Object.values(roomCounts).reduce((sum, count) => sum + count, 0);
        const totalRoomNum = Number(totalRoom) || 1;

        if (totalSelectedCount < totalRoomNum) {
            setRoomCounts((prev) => ({
                ...prev,
                [roomID]: (prev[roomID] || 0) + 1,
            }));

            // API call to get rate
            const ratePlanCode = selectedRatePlans[roomID]?.RateCodeID || "";
            const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;
            const rateTypeID = rateTypeCode === "Travel Agent" ? selectedAgentId || 0 : rateTypeCode === "Corporate" ? selectedCorporateId || 0 : 0;

            const rateCodeID = ratePlanCode || 0;
            const roomTypeID = roomID;
            const PropertyID = selectedProperty.PropertyID;

            try {
                const response = await getReserRoomRateSelect(rateCodeID, mealPlanID, roomTypeID, rateTypeCode || "", rateTypeID, PropertyID);

                const baseRate = response?.[0]?.BaseRate || 0;

                setSelectedPlans(prev => ({
                    ...prev,
                    [roomID]: {
                        ...prev[roomID],
                        PerRoomRate: baseRate
                    }
                }));

                console.log(`RoomID ${roomID} - BaseRate set to: ₹${baseRate}`);

            } catch (error) {
                console.log("Error fetching room rate", error);
            }
        }
    };


    const handleDecrement = (roomID) => {
        setRoomCounts((prev) => {
            const current = prev[roomID] || 0;
            if (current <= 1) {
                const updated = { ...prev };
                delete updated[roomID];
                return updated;
            } else {
                return {
                    ...prev,
                    [roomID]: current - 1,
                };
            }
        });
    };

    const handleSelectRoom = async (roomID) => {
        const qty = Number(totalRoom) || 1;

        // Set count for that room equal to selected totalRoom
        setRoomCounts(prev => ({
            ...prev,
            [roomID]: qty
        }));

        // Fetch rate once and set PerRoomRate
        const ratePlanCode = selectedRatePlans[roomID]?.RateCodeID || "";
        const mealPlanID = selectedMealPlans[roomID]?.MealPlanID || 0;
        const rateTypeID = rateTypeCode === "Travel Agent" ? selectedAgentId || 0 : rateTypeCode === "Corporate" ? selectedCorporateId || 0 : 0;
        const rateCodeID = ratePlanCode || 0;
        const roomTypeID = roomID;
        const PropertyID = selectedProperty.PropertyID;

        try {
            const response = await getReserRoomRateSelect(rateCodeID, mealPlanID, roomTypeID, rateTypeCode || "", rateTypeID, PropertyID);
            const baseRate = response?.[0]?.BaseRate || 0;

            setSelectedPlans(prev => ({
                ...prev,
                [roomID]: {
                    ...prev[roomID],
                    PerRoomRate: baseRate
                }
            }));

            console.log(`handleSelectRoom - RoomID ${roomID} - BaseRate set to: ₹${baseRate}`);
        } catch (error) {
            console.log("Error fetching room rate in handleSelectRoom", error);
        }
    };


    const totalSelectedCount = Object.values(roomCounts).reduce((sum, count) => sum + count, 0);

    const updateOccupancy = (roomID, index, type, action) => {
        const key = `${roomID}-${index}`;
        setRoomOccupancy(prev => {
            const current = prev[key] || { adults: 1, children: 0, extraBed: 0 };
            const updated = {
                ...current,
                [type]: Math.max(0, current[type] + (action === "increment" ? 1 : -1)),
            };
            return {
                ...prev,
                [key]: updated,
            };
        });
    };



    const handleContinueBooking = async () => {
        setLoading(true);
        const preBookingToken = localStorage.getItem("PreBookingToken");

        try {

            const missingMealPlans = [];

            for (const room of roomDetails) {
                const quantity = roomCounts[room.RoomID] || 0;
                if (quantity > 0) {
                    const meal = selectedMealPlans[room.RoomID];
                    // change condition if your meal object shape is different (e.g., check .MealPlanID)
                    if (!meal || (!meal.MealPlanID && !meal.Code)) {
                        missingMealPlans.push(room.RoomName || `RoomID ${room.RoomID}`);
                    }
                }
            }

            if (missingMealPlans.length > 0) {
                // build friendly message listing rooms
                const listStr = missingMealPlans.join(", ");
                swal({
                    title: "Select Meal Plan",
                    text: `Please select a meal plan for: ${listStr}`,
                    icon: "warning",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-warning"
                        }
                    }
                });
                setLoading(false);
                return; // stop further execution
            }

            for (const room of roomDetails) {
                const plan = selectedPlans[room.RoomID];
                const quantity = roomCounts[room.RoomID];

                if (plan && quantity) {
                    for (let i = 0; i < quantity; i++) {
                        const key = `${room.RoomID}-${i}`;
                        const occupancy = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };

                        const formData = new FormData();
                        formData.append("PropertyID", selectedProperty.PropertyID)
                        formData.append("ID", "0");
                        formData.append("PreBookingToken", preBookingToken);
                        formData.append("RoomID", room.RoomID);
                        formData.append("RatePlanID", selectedRatePlans[room.RoomID]?.Code || "");
                        formData.append("MealPlanID", selectedMealPlans[room.RoomID]?.Code || "");
                        formData.append("TotalRoom", 1);
                        formData.append("RoomRate", plan.PerRoomRate || "0");
                        formData.append("ExtraBed", occupancy.extraBed);
                        formData.append("ExtraBedAmount", occupancy.extraBed * plan.ExtraBedCharges || "0");
                        formData.append("Adults", occupancy.adults);
                        formData.append("Child", occupancy.children);
                        formData.append("Tax", 0);
                        formData.append("TaxRate", 0);
                        formData.append("NetAmount", 0);

                        // console.log("FormData to be sent:");
                        // for (let pair of formData.entries()) {
                        //     console.log(pair[0], ":", pair[1]);
                        // }

                        // API call
                        const result = await AddRoomDetails(formData);

                        if (result?.PreBookingToken) {
                            swal("Your Room Booked In Hotel", {
                                icon: "success",
                                buttons: {
                                    confirm: {
                                        text: "OK",
                                        className: "btn btn-success",
                                    },
                                },
                            }).then(() => {
                                navigate("/Reservation/FinalBooking");
                            });
                        } else if (result?.Message) {
                            swal(result.Message, {
                                icon: "error",
                                buttons: {
                                    confirm: {
                                        text: "OK",
                                        className: "btn btn-danger",
                                    },
                                },
                            });
                            return;
                        }
                    }
                }
            }

        } catch (err) {
            if (err.response?.data?.Message) {
                alert(err.response.data.Message);
            } else {
                swal("Something went wrong. Please try again.", {
                    icon: "error",
                    buttons: {
                        confirm: {
                            text: "OK",
                            className: "btn btn-danger",
                        },
                    },
                });
            }
        } finally {
            setLoading(false);
        }
    };


    const formatDateToDDMMYYYY = (dateString) => {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
    };

    useEffect(() => {
        const FetchPMS = async () => {
            if (!selectedProperty?.PropertyID) return;

            try {
                const result = await Property();
                const matched = result.find(
                    p => p.PropertyID === selectedProperty.PropertyID
                );
                setPMS(matched || null);
            } catch (error) {
                console.log("error fetch PMS", error);
            }
        };
        FetchPMS();
    }, [selectedProperty]);


    useEffect(() => {
        const fetchRatecode = async () => {
            setLoading(true);
            try {
                const result = await ReservationRateCodeList(selectedProperty?.PropertyID);
                if (Array.isArray(result)) setRatecode(result);
            } catch (error) {
                console.log("error get rate code", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRatecode();
    }, [selectedProperty]);

    useEffect(() => {
        const FetchMealplan = async () => {
            setLoading(true);
            try {
                const result = await ReservationMealplan(selectedProperty?.PropertyID);
                if (Array.isArray(result)) {
                    setMealplan(result);
                    setFilteredMealplan(result.filter(mp => mp.IsActive));
                }
            } catch (error) {
                console.log("error get meal plan", error);
            } finally {
                setLoading(false);
            }
        };
        FetchMealplan();
    }, [selectedProperty]);


    return (
        <>
            {loading && (
                <div className="fullscreen-loader">
                    <div className="fas fa-spinner fa-spin fa-3x " role="status"></div>
                </div>
            )}
            <div className="wrapper">
                <ReservationSidebar />
                <div className="main-panel">
                    <ReservationHeader />
                    <div className="container">
                        <div className="page-inner">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <div className="card-title">
                                                Reservation Booking
                                            </div>
                                        </div>
                                        <div className="card-body">
                                            <form>
                                                <div className="row">

                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label fw-bold">Check-In</label>
                                                            <input type="date" className="form-control" value={checkIn} onChange={handleCheckInChange} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label fw-bold">Check-Out</label>
                                                            <input type="date" className="form-control" value={checkOut}
                                                                onChange={(e) => setCheckOut(e.target.value)} />
                                                        </div>
                                                    </div>

                                                    <div className="col-md-2">
                                                        <div className="input-block">
                                                            <label className="col-form-label fw-bold">Rate Type</label>

                                                            <select className="form-select form-control" value={rateTypeCode}
                                                                onChange={(e) => setRateTypeCode(e.target.value)}>
                                                                <option>Select type</option>
                                                                {rateCodes.map((item, index) => (
                                                                    <option key={index} value={item.RateCodeType}>
                                                                        {item.RateCodeType}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                    </div>


                                                    {rateTypeCode === "Travel Agent" && (
                                                        <div className="col-md-3">
                                                            <div className="input-block ">
                                                                <label className="col-form-label fw-bold">Select Travel Agent</label>
                                                                <select
                                                                    className="form-select form-control"
                                                                    value={selectedAgentId}
                                                                    // onChange={(e) => setSelectedAgentId(e.target.value)}
                                                                    onChange={(e) => {
                                                                        setSelectedAgentId(e.target.value);
                                                                        const agent = agentList.find(a => a.AgentID === Number(e.target.value));
                                                                        if (agent?.MaxRoomBook) {
                                                                            setTotalRoom(Math.min(totalRoom, agent.MaxRoomBook));
                                                                        } else {
                                                                            setTotalRoom(1);
                                                                        }
                                                                    }}
                                                                >
                                                                    <option value="">Select Agent</option>
                                                                    {agentList.map(agent => (
                                                                        <option key={agent.AgentID} value={agent.AgentID}>
                                                                            {agent.TA_Name}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    )}


                                                    {/*  Conditional Select for Corporate */}
                                                    {rateTypeCode === "Corporate" && (
                                                        <div className="col-md-3">
                                                            <div className="input-block ">
                                                                <label className="col-form-label fw-bold">Select Corporate</label>
                                                                <select
                                                                    className="form-select form-control"
                                                                    value={selectedCorporateId}
                                                                    // onChange={(e) => setSelectedCorporateId(e.target.value)}
                                                                    onChange={(e) => {
                                                                        setSelectedCorporateId(e.target.value);
                                                                        const corp = corporateList.find(c => c.CorporateID === Number(e.target.value));
                                                                        if (corp?.MaxRoomBook) {
                                                                            setTotalRoom(Math.min(totalRoom, corp.MaxRoomBook));
                                                                        } else {
                                                                            setTotalRoom(1);
                                                                        }
                                                                    }}

                                                                >
                                                                    <option value="">Select Corporate</option>
                                                                    {corporateList.map((corp) => (
                                                                        <option key={corp.CorporateID} value={corp.CorporateID}>
                                                                            {corp.TA_Name} (CP_{corp.CorporateCode || "N/A"})
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    )}




                                                    <div className="col-md-2">
                                                        <div className="input-block ">
                                                            <label className="col-form-label fw-bold">Tolal Room</label>
                                                            <select className="form-select form-control" value={totalRoom}
                                                                onChange={(e) => setTotalRoom(e.target.value)}>
                                                                {(() => {
                                                                    let maxRoom = 28;

                                                                    if (rateTypeCode === "Travel Agent") {
                                                                        const agent = agentList.find(a => a.AgentID === Number(selectedAgentId));
                                                                        maxRoom = agent?.MaxRoomBook || 1;
                                                                    } else if (rateTypeCode === "Corporate") {
                                                                        const corp = corporateList.find(c => c.CorporateID === Number(selectedCorporateId));
                                                                        maxRoom = corp?.MaxRoomBook || 1;
                                                                    }

                                                                    return Array.from({ length: maxRoom }, (_, i) => (
                                                                        <option key={i + 1} value={i + 1}>{i + 1}</option>
                                                                    ));
                                                                })()}
                                                            </select>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-1 text-end">
                                                        <button type="button" className="btn btn-black " onClick={handleSearch} style={{ marginTop: "37px" }}><i className="fas fa-search"></i></button>
                                                    </div>

                                                </div>

                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {roomDetails.length > 0 && (
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card" style={{ marginBottom: "60px" }}>
                                            <div className="card-header">
                                                <div className="card-title">Room List</div>
                                            </div>
                                            <div className="card-body p-3">
                                                <table className="table align-middle text-center">
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th className="text-start">Room Type</th>
                                                            <th>Room Avl</th>
                                                            {Pms?.PMS === "Opera" && <th style={{ width: "185px" }}>Rate Plan</th>}
                                                            <th style={{ width: "185px" }}>Meal Plan</th>
                                                            <th>Quantity</th>
                                                            <th>Per Room Rate</th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {roomDetails.map((room) => {
                                                            // const ratePlans = room.RatePlan ? JSON.parse(room.RatePlan) : [];
                                                            const selectedRate = selectedRatePlans[room.RoomID];
                                                            // const mealPlans = selectedRate ? selectedRate.MealPlan : [];

                                                            return (
                                                                <tr key={room.RoomID}>
                                                                    {/* Room Name */}
                                                                    <td className="fw-bold text-start">{room.RoomName}</td>

                                                                    <td>{room.count || "0"}</td>

                                                                    {/* Rate Plan Dropdown */}
                                                                    {Pms?.PMS === "Opera" && (



                                                                        <td>
                                                                            <select
                                                                                className="form-select"
                                                                                value={selectedRatePlans[room.RoomID]?.Code || ""}
                                                                                onChange={(e) => handleRatePlanChange(room.RoomID, e.target.value, room)}
                                                                            >
                                                                                <option value="">Select Rate Plan</option>
                                                                                {ratecode.map((item) => (
                                                                                    <option key={item.RateCodeID} value={item.Code}>
                                                                                        {item.Name}
                                                                                    </option>
                                                                                ))}
                                                                            </select>
                                                                        </td>





                                                                    )}

                                                                    {/* Meal Plan Dropdown */}

                                                                    <td>

                                                                        <select
                                                                            className="form-select"
                                                                            value={selectedMealPlans[room.RoomID]?.MealPlanID || ""}
                                                                            onChange={(e) => handleMealPlanChange(room.RoomID, e.target.value)}
                                                                        >
                                                                            <option value="">Select Meal Plan</option>

                                                                            {filteredMealplan.map(mp => (
                                                                                <option key={mp.MealPlanID} value={mp.MealPlanID}>
                                                                                    {mp.Name}
                                                                                </option>
                                                                            ))}
                                                                        </select>


                                                                    </td>

                                                                    {/* Quantity */}
                                                                    <td>
                                                                        {selectedPlans[room.RoomID] && (
                                                                            roomCounts[room.RoomID] ? (
                                                                                <div className="hstack gap-2 justify-content-center">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                                        onClick={() => handleDecrement(room.RoomID)}
                                                                                    >
                                                                                        <i className="fas fa-minus"></i>
                                                                                    </button>
                                                                                    <span className="fw-semibold">
                                                                                        {roomCounts[room.RoomID]}
                                                                                    </span>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-outline-secondary btn-sm px-2 py-1"
                                                                                        onClick={() => handleIncrement(room.RoomID)}
                                                                                    >
                                                                                        <i className="fas fa-plus"></i>
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <button
                                                                                    className="btn btn-sm btn-black"
                                                                                    onClick={() => handleSelectRoom(room.RoomID)}
                                                                                >
                                                                                    Select Room
                                                                                </button>
                                                                            )
                                                                        )}
                                                                    </td>

                                                                    {/* Per Room Rate */}
                                                                    <td>
                                                                        {selectedPlans[room.RoomID] && (
                                                                            <span className="fw-semibold">
                                                                                ₹ {selectedPlans[room.RoomID].PerRoomRate}
                                                                            </span>
                                                                        )}
                                                                    </td>


                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            )}


                            {totalSelectedCount > 0 && (
                                <div
                                    className="bg-light border-top text-end px-4 py-3"
                                    style={{
                                        position: "fixed",
                                        bottom: 0,
                                        left: 0,
                                        width: "100%",
                                        zIndex: 999,
                                        boxShadow: "0 -2px 5px rgba(0,0,0,0.1)"
                                    }}
                                >
                                    <button className="btn btn-black" onClick={() => setShowPopup(true)}>Continue ( {totalSelectedCount} ) </button>
                                </div>
                            )}



                            {showPopup && (
                                <div
                                    className="modal d-block"
                                    tabIndex="-1"
                                    style={{
                                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        zIndex: 1050,
                                        padding: "18px",
                                    }}
                                >
                                    <div
                                        className="modal-dialog"
                                        style={{
                                            maxWidth: "600px",
                                            width: "100%",
                                        }}
                                    >
                                        <div
                                            className="modal-content"
                                            style={{
                                                borderRadius: "10px",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div className="modal-header">
                                                <h5 className="modal-title">Selected Rooms</h5>
                                            </div>

                                            <div className="modal-body p-3">
                                                {/* Date display */}
                                                <div className="d-flex justify-content-between mb-3">
                                                    <div><strong>From:</strong> {formatDateToDDMMYYYY(checkIn)}</div>
                                                    <div><strong>To:</strong> {formatDateToDDMMYYYY(checkOut)}</div>
                                                </div>


                                                {roomDetails
                                                    .filter(room => roomCounts[room.RoomID])
                                                    .flatMap((room) => {
                                                        const quantity = roomCounts[room.RoomID] || 0;
                                                        const plan = selectedPlans[room.RoomID];

                                                        return Array.from({ length: quantity }, (_, i) => {
                                                            const key = `${room.RoomID}-${i}`;
                                                            const occupancy = roomOccupancy[key] || { adults: 1, children: 0, extraBed: 0 };

                                                            return (
                                                                <div key={key} className="bg-light p-3 rounded mb-3 position-relative">
                                                                    {/* Room Info */}
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <strong>{room.RoomName}</strong>
                                                                        <div>
                                                                            {Pms?.PMS === "Opera" && (
                                                                                <span>Rate Plan: <strong className="text-danger">{plan?.RatePlanName}<br /></strong></span>
                                                                            )}


                                                                            <span>Meal Plan: <strong className="text-danger">{plan?.MealPlanName}</strong></span>
                                                                        </div>
                                                                    </div>

                                                                    {/* Occupancy Controls */}
                                                                    <div className="row">
                                                                        <div className="col-md-2">
                                                                            <label className="fw-bold">Adults</label>
                                                                            <div className="hstack gap-2 mb-2">
                                                                                <button onClick={() => updateOccupancy(room.RoomID, i, 'adults', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                    <i className="fas fa-minus"></i>
                                                                                </button>
                                                                                <span>{occupancy.adults}</span>
                                                                                <button onClick={() => updateOccupancy(room.RoomID, i, 'adults', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                    <i className="fas fa-plus"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-2">
                                                                            <label className="fw-bold">Children</label>
                                                                            <div className="hstack gap-2 mb-2">
                                                                                <button onClick={() => updateOccupancy(room.RoomID, i, 'children', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                    <i className="fas fa-minus"></i>
                                                                                </button>
                                                                                <span>{occupancy.children}</span>
                                                                                <button onClick={() => updateOccupancy(room.RoomID, i, 'children', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                    <i className="fas fa-plus"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-md-3">
                                                                            <label className="fw-bold">Extra Bed</label>
                                                                            <div className="hstack gap-2 mb-2">
                                                                                <button onClick={() => updateOccupancy(room.RoomID, i, 'extraBed', 'decrement')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                    <i className="fas fa-minus"></i>
                                                                                </button>
                                                                                <span>{occupancy.extraBed}</span>
                                                                                <button onClick={() => updateOccupancy(room.RoomID, i, 'extraBed', 'increment')} className="btn btn-outline-secondary btn-sm py-1 px-2">
                                                                                    <i className="fas fa-plus"></i>
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="fw-bold fs-5 position-absolute" style={{ bottom: "10px", right: "15px" }}>
                                                                        ₹ {plan?.PerRoomRate + (occupancy.extraBed * plan?.ExtraBedCharges || 0)}
                                                                    </div>
                                                                </div>
                                                            );
                                                        });
                                                    })}


                                            </div>

                                            <div className="modal-footer">
                                                <button className="btn btn-danger" onClick={() => setShowPopup(false)}>Cancel</button>
                                                <button className="btn btn-primary" onClick={handleContinueBooking}>Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
